<!--
@Author: Calvin Green <calvin>
@Date:   2022-04-07T21:34:07+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-04-11T13:43:21+02:00
@Copyright: Diversitude 2022
-->

<template>
    <b-row>
        <b-col cols="12" v-show="action == 'list_slas'">
            <div style="margin-top: 5px; margin-bottom: 10px;">
                <b-button variant="primary" @click="addSLA()">Add SLA</b-button>
            </div>
            <div v-show="supplierSlas.length == 0">
                <div style="text-align: center; font-size: 25px;">
                    <span>Please add a SLA!</span>
                </div>
            </div>
            <div v-show="supplierSlas.length > 0">
                <webix-ui :config="ui" v-model="supplierSlas"></webix-ui>
            </div>
        </b-col>
        <b-col cols="12" v-show="action == 'view_sla'">
            <div style="margin-top: 5px; margin-bottom: 10px;">
                <b-button variant="primary" @click="changeAction('list_slas')">Back</b-button>
            </div>
            <iframe :src="viewSrc" width="100%" height="500px"></iframe>
        </b-col>
        <b-modal ref="sla-modal" hide-footer title="Add Supplier SLA">
          <div class="d-block text-center">
              <b-form>
                  <b-form-group
                    class="mb-4"
                    label="Revise Date: "
                    label-for="sla-datepicker"
                    label-cols-sm="4"
                  >
                  <b-form-datepicker id="sla-datepicker" v-model="slaData.revise_date"></b-form-datepicker>
                  </b-form-group>
                  <b-form-group
                    class="mb-4"
                    label="SLA Upload: "
                    label-for="sla-datepicker"
                    label-cols-sm="4"
                  >
                  <uploader :options="renderUploadOptions()" :autoStart="false" :ref="'sla_upload'" class="uploader-example">
                      <uploader-unsupport></uploader-unsupport>
                          <uploader-drop>
                              <p>Drop file here to upload or</p>
                              <uploader-btn type="button" :single="false"><i class="fas fa-file fa-fw"></i> Select file</uploader-btn>&nbsp;
                          </uploader-drop>
                      <uploader-list></uploader-list>
                  </uploader>
                  </b-form-group>
              </b-form>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="saveSLA()">Save</button>
                <button type="button" class="btn btn-secondary" @click="addSLA()">Close</button>
              </div>
          </div>
        </b-modal>
    </b-row>
</template>
<script>
import { facilityAdminMethods } from '@/state/helpers'
import Swal from "sweetalert2";
export default {
    data:() => ({
        action: "list_slas",
        ui: {
            id: 'suppliersSLATable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            autoheight: true,
            //hover: "datatableHover",
            //minHeight:50,
            //minWidth: 50,
            minColumnWidth: 120,
            scrollY:false,
            scrollX:true,
            resizeColumn: true,
            select: false,
            data:[],
            columns:[
                //{ id: 'company_name', header:'Company Name', fillspace: true},
                { id: 'revision_id', template:"<span class='viewAction' style='cursor: pointer;'>#revision_id#</span>", header:["SLA Revision ID", {content: "textFilter"}], tooltip:false, fillspace: 0.6},
                { id: 'revision_date', header:'Revision Date', fillspace: 0.6},
                { id: 'upload_user_name', header:'Upload User', fillspace: 0.6},
                { id: 'actions', header:'Actions', fillspace: 0.2,  template: function(){
                    return '<div style="cursor: pointer;"><i title="View Supplier" class="viewAction webix_icon_hover webix_icon delete_icon fas fa-binoculars"></i>&nbsp;<i title="View comment" class="deleteAction webix_icon_hover webix_icon delete_icon fas fa-trash"></i></div>'
                }}
            ],
            on:{

            },
            onClick:{//eslint-disable-next-line
                viewAction: function(id, e, trg) {
                    var el = this.$scope.$parent;
                    var item = this.getItem(e.row);
                    el.getSupplierSLAPreviewLink({revision_id: item.revision_id}).then((response)=>{
                        el.viewSrc = response.temp_url + '#toolbar=1';
                        el.action = "view_sla";
                    });
                },//eslint-disable-next-line
                deleteAction: function(id, e, trg) {
                    var el = this.$scope.$parent;
                    Swal.fire({
                      title: "Are you sure you want to delete this SLA?",
                      text: "You won't be able to revert this!",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#34c38f",
                      cancelButtonColor: "#f46a6a",
                      confirmButtonText: "Yes, delete it!"
                    }).then(result => {
                      if (result.value) {
                          el.deleteSupplierSLA({supplier_sla_id: e.row}).then(()=>{
                              el.$emit('updatedSupplier');
                          });
                      }
                  });
                }
            },
        },
        slaData: {
            revise_date: ""
        },
        viewSrc: "",
        supplierSlas: []
    }),
    props: {
        slas: {
            required: true
        },
        supplierId: Number
    },
    watch: {
        slas(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                this.supplierSlas = newVal;
            }
        }
    },
    computed: {

    },
    methods: {
        ...facilityAdminMethods,
        addSLA() {
            this.slaData = {
                revise_date: ""
            };
            this.$refs['sla-modal'].toggle('#toggle-btn')
        },
        changeAction(action) {
            this.action =  action;
            setTimeout(function () {
                /* eslint-disable no-undef */
                $$("suppliersSLATable").refresh();
                $$("suppliersSLATable").refreshColumns();
                /* eslint-enable no-undef */
            }, 250);
        },
        renderUploadOptions() {
            var storage = window.localStorage;
            var AUTH_TOKEN = storage.getItem('x_token');
            var url = process.env.VUE_APP_API_BASEURL + 'api/facilityadmin/uploadsuppliersla';
            var options = {
                target: url,
                query: {
                    client_supplier_id: this.supplierId,
                },
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                withCredentials: true,
                testChunks: false,
                fileParameterName: 'supplier_sla', //Set the upload post param which will contain the binary payload
                singleFile: false, //Limit upload to one file
            };
            return options;
        },
        saveSLA() {
            if (this.slaData.revise_date == "") {
                Swal.fire("Error", "Check your form!", "error");
                return;
            }
            const uploaderInstance = this.$refs['sla_upload'];
            const upload = uploaderInstance.uploader;
            upload.opts.query.revision_date = this.slaData.revise_date;
            upload.resume();
            //eslint-disable-next-line no-unused-vars
            upload.on('fileSuccess', (rootFile, file, message, chunk)=>{
                var response = JSON.parse(message);
                if(response.success){
                    this.$emit('updatedSupplier');
                    this.addSLA();
                    Swal.fire("Uploaded", "SLA has been uploaded!", "success");
                    upload.off("fileSuccess");
                    upload.cancel();
                }
                else {
                   //eslint-disable-next-line no-console
                    console.log("Upload error");
                }
            });
        }
    },
    mounted() {

    },
}
</script>
